import { isFunction, some, isEmpty } from 'underscore';
import { merge } from '@bingads-webui/primitive-utilities';
import {
  campaignSettingsStyles,
  creationCommonStyle,
  dsaCampaignStyles,
} from '@bingads-webui-campaign-react/campaign-adgroup-settings-shared-styles';
import {
  helpbuttonStyle, linkStyle, containerBudgetStyle,
  sharedBudgetGridWrapper, inputFieldStyle
} from '@bingads-webui-campaign-react/common-styles';
import { stepWizardStyle } from './step-wizard';
import { CreationContainerContentOverrideStyle } from './creation-content-container-style';

function resolveStyles(theme, ...styles) {
  const resolvedStyles = styles.map(s => (isFunction(s) ? s(theme) : s));
  if (some(resolvedStyles, isEmpty)) {
    throw new Error('Cannot pass in empty style!');
  }
  return resolvedStyles;
}
export const getSearchCreationStyle = (_, { palette = {} }) => {
  const globalStyles = merge(
    {},
    ...resolveStyles(
      { palette },
      stepWizardStyle,
      helpbuttonStyle,
      inputFieldStyle,
      CreationContainerContentOverrideStyle
    )
  );
  const commonStyles = merge(
    {},
    ...resolveStyles(
      { palette },
      containerBudgetStyle,
      sharedBudgetGridWrapper,
      linkStyle
    )
  );
  const searchCreationStyles = merge(
    {},
    ...resolveStyles(
      { palette },
      dsaCampaignStyles,
      campaignSettingsStyles,
      creationCommonStyle
    )
  );
  return {
    '@global': globalStyles,
    CampaignCreationSearch: {
      ...searchCreationStyles,
      ...commonStyles,
    },
  };
};
